import { render, staticRenderFns } from "./ChatBotMsgHistory.vue?vue&type=template&id=106f8f2c&"
import script from "./ChatBotMsgHistory.vue?vue&type=script&lang=js&"
export * from "./ChatBotMsgHistory.vue?vue&type=script&lang=js&"
import style0 from "./ChatBotMsgHistory.vue?vue&type=style&index=0&id=106f8f2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports